var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5294 3.16462L20.8119 19.1059C21.275 20.1195 20.8536 21.3284 19.8708 21.806C19.3302 22.0687 18.7031 22.0637 18.1664 21.7924L12.1827 18.7673C11.9096 18.6293 11.5899 18.6293 11.3168 18.7673L5.3331 21.7924C4.35753 22.2856 3.17901 21.8698 2.7008 20.8637C2.43776 20.3102 2.43292 19.6635 2.68764 19.1059L9.97018 3.16462C10.4333 2.15097 11.6054 1.7164 12.5882 2.194C13.0018 2.39494 13.3345 2.73814 13.5294 3.16462ZM12.1947 3.81319C12.146 3.70657 12.0628 3.62077 11.9594 3.57054C11.7312 3.45967 11.4623 3.54542 11.3323 3.76114L11.3049 3.81319L4.02233 19.7544C3.95865 19.8938 3.95986 20.0555 4.02562 20.1939C4.13663 20.4275 4.3986 20.5338 4.63074 20.4491L4.68369 20.4261L10.6674 17.401C11.3123 17.075 12.0609 17.0569 12.7173 17.3467L12.8321 17.401L18.8158 20.4261C18.95 20.4939 19.1068 20.4952 19.2419 20.4295C19.4701 20.3186 19.5772 20.0501 19.4987 19.8094L19.4772 19.7544L12.1947 3.81319Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my-location.bc6ad6da727c367fea1b63daab2f9963.svg";
export { ForwardRef as ReactComponent };